import { createAxios } from "./axiosHttpMarconi";

export const procesosService = {
  getList,
  getById,
};

function getList(pagination, filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/procesos`;
  const params = new URLSearchParams({ ...pagination, ...filters });

  urlPath += `?${params.toString()}`;
  return axios.get(urlPath);
}

function getById(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquciadora/${user.extraData.franquiciadoraId}/procesos/${id}`;
  return axios.get(urlPath);
}
